"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.GalleryAPI = void 0;
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _NextApiClient = require("./NextApiClient");
var GalleryAPI = /*#__PURE__*/function () {
  function GalleryAPI() {
    (0, _classCallCheck2["default"])(this, GalleryAPI);
  }
  (0, _createClass2["default"])(GalleryAPI, null, [{
    key: "createTag",
    value: function createTag(tagName, catalog) {
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var errCb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (err) {
        console.error(err);
      };
      var params = {
        data: (0, _stringify["default"])({
          catalog: catalog,
          tagName: tagName
        })
      };
      _NextApiClient.NextApiClient.com(this.service, 'jGalleryCreateTag', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (errCb) errCb(err);
      });
    }
  }, {
    key: "getTags",
    value: function getTags(catalog) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var errCb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (err) {
        console.error(err);
      };
      var params = {
        data: (0, _stringify["default"])({
          catalog: catalog
        })
      };
      _NextApiClient.NextApiClient.com(this.service, 'jGalleryGetTagList', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (errCb) errCb(err);
      });
    }
  }, {
    key: "gallerySave",
    value: function gallerySave(catalog, data) {
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var errCb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (err) {
        console.error(err);
      };
      var dataParams = {
        catalog: catalog,
        cod: null,
        img: null,
        des: null,
        tagList: [],
        flag: 0,
        assignTo: null,
        isPrivate: 0,
        idFolder: 1
      };
      (0, _assign["default"])(dataParams, data);
      var params = {
        Catalogo: catalog,
        data: (0, _stringify["default"])(dataParams)
      };
      _NextApiClient.NextApiClient.com(this.service, 'jGallerySave', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (errCb) errCb(err);
      });
    }
  }, {
    key: "gallerySearch",
    value: function gallerySearch(catalog, data) {
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var errCb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (err) {
        console.error(err);
      };
      var dataParams = {
        tagList: [],
        galleryLayouts: []
      };
      (0, _assign["default"])(dataParams, data);
      var params = {
        Catalogo: catalog,
        data: (0, _stringify["default"])(dataParams)
      };
      _NextApiClient.NextApiClient.com(this.service, 'jGallerySearch', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (errCb) errCb(err);
      });
    }
  }, {
    key: "galleryLoad",
    value: function galleryLoad(catalog, cod) {
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var errCb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (err) {
        console.error(err);
      };
      var params = {
        Catalogo: catalog,
        cod: cod
      };
      _NextApiClient.NextApiClient.com(this.service, 'jGalleryLoad', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (errCb) errCb(err);
      });
    }
  }, {
    key: "galleryDelete",
    value: function galleryDelete(catalog, cod) {
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (err) {
        console.error(err);
      };
      var params = {
        Catalogo: catalog,
        cod: cod
      };
      _NextApiClient.NextApiClient.com(this.service, 'GalleryDelete', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "createFolder",
    value: function createFolder(folderName, parentId, catalog) {
      var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.log(j);
      };
      var errCb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (err) {
        console.error(err);
      };
      var params = {
        catalog: catalog,
        folderName: folderName,
        parentId: parentId
      };
      _NextApiClient.NextApiClient.com(this.service, 'JCreateFolder', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (errCb) errCb(err);
      });
    }
  }, {
    key: "deleteFolder",
    value: function deleteFolder(folderId, catalog) {
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var errCb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (err) {
        console.error(err);
      };
      var params = {
        catalog: catalog,
        folderId: folderId
      };
      _NextApiClient.NextApiClient.com(this.service, 'JDeleteFolder', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (errCb) errCb(err);
      });
    }
  }, {
    key: "getFolderList",
    value: function getFolderList(catalog) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var errCb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (err) {
        console.error(err);
      };
      var params = {
        catalog: catalog
      };
      _NextApiClient.NextApiClient.com(this.service, 'JGetFolderList', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (errCb) errCb(err);
      });
    }
  }, {
    key: "getCreationPriviledges",
    value: function getCreationPriviledges(catalog) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var errCb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (err) {
        console.error(err);
      };
      var params = {
        catalog: catalog
      };
      _NextApiClient.NextApiClient.com(this.service, 'JGetPrivMatrix', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (errCb) errCb(err);
      });
    }
  }, {
    key: "setCreationPriviledges",
    value: function setCreationPriviledges(catalog, privileges) {
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var errCb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (err) {
        console.error(err);
      };
      var params = {
        catalog: catalog,
        data: (0, _stringify["default"])(privileges)
      };
      _NextApiClient.NextApiClient.com(this.service, 'JPutPrivMatrix', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (errCb) errCb(err);
      });
    }
  }]);
  return GalleryAPI;
}();
exports.GalleryAPI = GalleryAPI;
GalleryAPI.service = 'pgallery';
//# sourceMappingURL=GalleryAPI.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/api/GalleryAPI.js
// module id = 1219
// module chunks = 142